import Dashboard from "../../views/dashboard/Dashboard.vue";

const property = {
  path: "/propertymanagement",
  name: "propertymanagement",
  redirect: "propertyrepair",
  component: Dashboard,
  meta: {
    title: "物业管理",
    icon: "el-icon-menu",
    role: false
  },
  children: [
    {
      path: "/propertyrepair",
      name: "propertyrepair",
      component: () =>
        import("../../components/propertymanagement/propertyrepair.vue"),
      meta: {
        title: "物业报修",
        icon: "el-icon-s-cooperation",
        role: false
      }
    },
    {
      path: "/propertyadviser",
      name: "propertyadviser",
      component: () =>
        import("../../components/propertymanagement/propertyadviser.vue"),
      meta: {
        title: "投诉建议",
        icon: "el-icon-headset",
        role: false
      }
    },
    {
      path: "/propertypay",
      name: "propertypay",
      component: () =>
        import("../../components/propertymanagement/propertypay.vue"),
      meta: {
        title: "物业缴费",
        icon: "el-icon-coin",
        role: false
      }
    }
  ]
};

export default property;
